import { TDiagnosisEntity } from "../services/diagnosis/types";

const platformsWithPhoneUnavailable = ["Instagram", "Facebook"];

const getPercentage = (value: number, total: number) =>
  parseFloat(Math.round((value * 100) / total).toFixed(2));

export default function getDiagnosisStatusPercentage(
  diagnosisLists: TDiagnosisEntity[]
) {
  const { correct, incorrect, nonexistent, total } = diagnosisLists.reduce(
    (counter, diagnosis) => {
      const { address_status, phone_status, name_status, platform } = diagnosis;

      const platformReturnsPhone =
        !platformsWithPhoneUnavailable.includes(platform);

      if (platformReturnsPhone && diagnosis.phone !== "irrelevant") {
        counter[phone_status] += 1;
        counter.total += 1;
      }

      if (diagnosis.address !== "irrelevant") {
        counter[address_status] += 1;
        counter.total += 1;
      }

      if (diagnosis.name !== "irrelevant") {
        counter[name_status] += 1;
        counter.total += 1;
      }

      return counter;
    },
    { correct: 0, incorrect: 0, nonexistent: 0, total: 0 }
  );

  console.log({
    correct,
    incorrect,
    nonexistent,
    total,
  });

  return {
    correct: getPercentage(correct, total),
    incorrect: getPercentage(incorrect, total),
    nonexistent: getPercentage(nonexistent, total),
  };
}
